<template>
  <!-- Loading message when isLoading is true -->
  <div
    v-if="isLoading"
    class="d-flex justify-content-center align-items-center"
    style="height: 40vh"
  >
    <div class="custom-spinner" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

  <!-- Error Handling -->
  <div v-if="!isLoading && errorMessage.length > 0" class="alert alert-danger">
    <strong>Erro!</strong> {{ errorMessage }}
  </div>

  <!-- SurveyForm component when isLoading is false -->
  <SurveyForm
    v-if="!isLoading && survey && survey.length > 0"
    :questions="getSectionQuestions()"
    :section="section"
    :sections="sections"
    :survey="survey"
    :questionMap="questionMap"
    :allQuestionIds="allQuestionIds"
    :CAE="CAE"
    :Municipalities="Municipalities"
    @change-section="changeSection"
    @save-answers="saveAnswers"
    @download-template="downloadTemplate"
    @error-handling="errorHandling"
  >
  </SurveyForm>
</template>

<script>
// import child component
import SurveyForm from '@/components/survey/SurveyForm.vue';
export default {
  components: {
    SurveyForm,
  },

  data() {
    return {
      survey: [], // Survey questions and possible answers
      sections: [], // Dictionary with unique section ids and descriptions
      section: localStorage.getItem('lastSection') || 'S0', // Initial section when loading
      isLoading: false, // Sets the Loading Spinner On and Off
      errorMessage: '', // Error message to display to the user
      allQuestionIds: [], // Array with all question_ids
      Municipalities: [], // All municipalities options to display in dropdown
      CAE: [], // All CAE options to display in dropdown
    };
  },

  created() {
    // load the survey from the backend when we mount
    this.loadSurvey();
  },

  methods: {
    // method to load survey from the backend
    async loadSurvey() {
      // Set the Loading Spinner On
      this.setLoading(true);
      // Dispatch the action to load the survey questions
      var loadMessage = await this.$store.dispatch('survey/loadSurvey');

      // Check if the survey was loaded successfully
      if (loadMessage !== true) {
        this.errorHandling(
          'Erro ao trazer as perguntas do formulário da base de dados: ' +
            loadMessage +
            '.'
        );
      }

      // Get the survey data from the store
      this.survey = this.$store.getters['survey/survey'];
      this.sections = this.$store.getters['survey/sections'];
      this.CAE = this.$store.getters['survey/CAE'];
      const municipalityArray = this.$store.getters['survey/Municipality'];
      const municipalityIds = municipalityArray.map((item) => item.id);
      this.Municipalities = municipalityIds;
      
      // Create a mapping of question IDs to their descriptions
      this.questionMap = {};
      this.survey.forEach((question) => {
        this.questionMap[question.question_Id] = {
          description: question.question_Desc, // Store the description
          type: question.question_Type, // Store the question type
        };
      });

      // Get all question_ids
      this.allQuestionIds = this.survey.map((question) => question.question_Id);

      // Set the Loading Spinner Off
      this.setLoading(false);
    },

    // return the questions from the specific section
    getSectionQuestions() {
      //Filter the questions by section
      return this.survey.filter(
        (question) => question.section_Id === this.section
      );
    },

    // change the current section to the selected section by the user
    changeSection(newSection) {
      this.section = newSection;
    },

    // dispatch the action to save the answers and company Info
    async saveAnswers(data) {
      // set the answers in the store state
      this.$store.commit('survey/setSelectedAnswers', data.selectedAnswers);

      // Set the Loading Spinner On
      this.setLoading(true);
      // Dispatch the action to save the answers
      var loadMessage = await this.$store.dispatch('survey/registerAnswers', {
        currentYear: data.currentYear,
        priorYear: data.priorYear,
        Company_Id: data.Company_Id,
      });

      // Set the Loading Spinner Off
      this.setLoading(false);

      // Check if the survey was loaded successfully
      if (loadMessage !== true) {
        loadMessage =
          'Erro ao guardar os resultados na base de dados. Por favor, comece novamente o formulário.';
        this.errorHandling(loadMessage);
      } else {
        // if so redirect to the Result page
        await this.$store.dispatch('survey/setButtonPressed', true);
        this.$router.replace('/results');
        localStorage.clear();
      }
    },

    // method to download templates from the backend
    async downloadTemplate() {
      try {
        // Get the file content to be downloaded
        const resultBlob = await this.$store.dispatch(
          'survey/downloadTemplate'
        );

        // receive the template and download it
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(resultBlob);
        a.download = 'Iniciativas_e_Projetos_de_Descarbonizao';
        a.click();

        // Revoke the object URL
        window.URL.revokeObjectURL(a.href);
      } catch (error) {
        // Handle the error and display the error message
        this.errorHandling(
          error.message || 'Erro ao fazer download do ficheiro'
        );
      }
    },

    // Set the isLoading value
    setLoading(value) {
      this.isLoading = value;
    },

    // deal with error messages
    errorHandling(error) {
      this.errorMessage = error;

      if (this.errorMessage.length > 0) {
        //Scroll to the top of the page
        window.scrollTo({
          top: 0,
          behavior: 'smooth', // Scroll behavior
        });
      }
    },
  },
};
</script>
